<template>
  <OmtLayoutContainer>
    <OmtRow mb="24px">
      <OmtTypography as="h1-bold" v-if="queryType === 'pedido'">
        Envio de pedido médico para análise de coberturas
      </OmtTypography>
      <OmtTypography as="h1-regular" v-else>
        <omt-bold>Envio das imagens </omt-bold> {{ isOtherMatters ? "(opcional)" : "" }}
      </OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="p1" color="#4E4E4E" font-weight="600 !important" v-if="queryType === 'pedido'">
        Nos envie o pedido médico com a descrição dos exames para analisarmos as coberturas.
      </OmtTypography>
      <OmtTypography as="p1" color="#4E4E4E" font-weight="600 !important" v-else>
        Insira a imagem referente a sua solicitação:
      </OmtTypography>
    </OmtRow>
    <OmtRow>
      <ImageUploader @change="onImageUploaderChange" :length="limitFiles" :initialValue="pictures" />
    </OmtRow>

    <OmtRow :desktopStart="1" :desktopEnd="6" :gridRowStart="['initial', '2']">
      <CBox>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            <b>Arquivos suportados:</b> .jpg, .png, .heic e .pdf. com até 25mb.
          </OmtTypography>
        </CFlex>

        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            Envie apenas <b>um documento por foto</b>.
          </OmtTypography>
        </CFlex>

        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)">
            Certifique-se de que todas as informações das imagens estão legíveis.
          </OmtTypography>
        </CFlex>
      </CBox>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="next" :disabled="disableButton">
        {{ isOtherMatters ? "Enviar" : "Continuar" }}
      </OmtButton>
    </OmtRow>
    <SentRequestModal
      :isOpen="modalSuccess"
      :daysAnalizy="daysAnalizy"
      :protocol="protocolANS"
      @close="closeModal"
      @save="saveEvaluation"
    />
  </OmtLayoutContainer>
</template>
<script>
import ImageUploader from "@/components/Molecules/ImageUploader";
import SentRequestModal from "@/components/Organisms/Requests/SentRequestModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "UploadFileRequest",
  components: { ImageUploader, SentRequestModal },
  data() {
    return {
      pictures: [],
      requireAuth: true,
      daysAnalizy: 2,
      modalSuccess: false,
      protocolANS: ""
    };
  },

  computed: {
    ...mapState("request", ["addPermission", "limitFiles", "newRequest", "subjectOptions"]),
    queryType() {
      return this.$route.query?.tipo ?? "";
    },
    isOtherMatters() {
      return this.subjectOptions.find(s => s.value === this.newRequest.subject)?.outros || false;
    },
    disableButton() {
      return this.pictures.length === 0 && !this.isOtherMatters;
    }
  },
  methods: {
    ...mapActions("request", ["createRequestTicket", "fetchProtocols"]),
    ...mapActions("ticket", ["saveExpRating"]),
    ...mapMutations("request", ["SET_PICTURES", "RESET_NEW_REQUEST", "SET_NEW_REQUEST_SUCCESS"]),
    onImageUploaderChange(pictures) {
      this.pictures = pictures?.filter(pic => pic.source && pic.name) ?? [];
    },
    async next() {
      await this.SET_PICTURES(this.pictures);

      if (this.isOtherMatters) {
        await this.submit();
        return;
      }

      this.$router.push({
        name: "request.observation",
        params: {
          requireAuth: this.requireAuth
        }
      });
    },
    closeModal() {
      this.$router.push("/solicitacoes");
    },
    async saveEvaluation({ rating, obs }) {
      await this.$root.$emit("show-loading");
      try {
        await this.saveExpRating({
          ticket: this.protocolANS,
          type: "9",
          step: "S",
          rating,
          obs
        });
      } finally {
        this.$router.push("/solicitacoes");
      }
    },
    async submit() {
      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.createRequestTicket({ obs: this.newRequest.observation });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (response && response.Data) {
        this.daysAnalizy = response.Data.prazos;
        this.protocolANS = response.Data.protocoloANS;
        this.modalSuccess = true;
        this.SET_NEW_REQUEST_SUCCESS(true);
        this.RESET_NEW_REQUEST();
        this.fetchProtocols({ protocol: this.protocolANS });
      } else {
        await this.$toast({
          description: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    }
  },
  mounted() {
    if (!this.addPermission) {
      this.$router.replace("/solicitacoes");
      return;
    }
    if (!this.newRequest?.subject) {
      this.$router.replace("/solicitacoes/criar");
      return;
    }
    const subject = this.subjectOptions.find(s => s.value === this.newRequest.subject);
    this.requireAuth = !!subject?.authorizationService;
    this.pictures = this.newRequest?.pictures ?? [];
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped></style>
